import { render, staticRenderFns } from "./print-table-bottom.vue?vue&type=template&id=7868c224"
import script from "./print-table-bottom.vue?vue&type=script&lang=js"
export * from "./print-table-bottom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports